export default "__VITE_ASSET__JLBj_V8i__"